// Referral capture: read ?ref=CODE from any landing URL and remember it for 30 days
// so it survives the visit -> register flow, then attach it to the signup request.

export const REF_KEY = 'se_ref';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

// Store the code (sanitized) whenever a ?ref= is present on the current URL.
export function captureRefFromUrl(search) {
  try {
    const qs = search != null ? search : (typeof window !== 'undefined' ? window.location.search : '');
    const raw = new URLSearchParams(qs).get('ref');
    if (!raw) return;
    const code = raw.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 24);
    if (!code) return;
    localStorage.setItem(REF_KEY, JSON.stringify({ code, ts: Date.now() }));
  } catch {}
}

// Return the stored code if still within the TTL, else clean it up and return null.
export function getStoredRef() {
  try {
    const v = JSON.parse(localStorage.getItem(REF_KEY));
    if (!v || !v.code) return null;
    if (Date.now() - v.ts > TTL_MS) { localStorage.removeItem(REF_KEY); return null; }
    return v.code;
  } catch { return null; }
}

export function clearStoredRef() {
  try { localStorage.removeItem(REF_KEY); } catch {}
}
